module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/5ebcba91993bc09b9c0763d2946582d8.png";